module.exports = __webpack_public_path__ + "assets/img/main-logo-chengde.0d03f12e.png";